<div
    class="overlay"
    [ngStyle]="{'z-index': zIndexOverride}"
    [attr.data-qa-id]="'overlay'"
></div>
